/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Tuda_Online_Digital17Inputs */

const en__field_enum_tuda_online_digital17 = /** @type {(inputs: _Field_Enum_Tuda_Online_Digital17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online`)
};

const de__field_enum_tuda_online_digital17 = /** @type {(inputs: _Field_Enum_Tuda_Online_Digital17Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`online`)
};

/**
* | output |
* | --- |
* | "online" |
*
* @param {_Field_Enum_Tuda_Online_Digital17Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_tuda_online_digital17 = /** @type {((inputs?: _Field_Enum_Tuda_Online_Digital17Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Tuda_Online_Digital17Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_tuda_online_digital17(inputs)
	return de__field_enum_tuda_online_digital17(inputs)
});
export { _field_enum_tuda_online_digital17 as "_field_enum_TUDA_ONLINE_DIGITAL" }